import { useContext, useMemo } from "react";
import { UserContext } from "../components/auth/auth-context";

export const useAuthStatus = () => {
  const { providerUser } = useContext(UserContext);

  const isLoggedIn = useMemo(() => {
    return !!providerUser?.userId;
  }, [providerUser]);

  return {
    isLoggedIn,
    providerUser,
  };
};
